import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import BeneficiariesOverviewComponent from './component'
import { parseFilters } from './helper'

// Storage key for persisting filter state (must match the key in filters/container.js)
const MARKETING_FILTER_KEY = 'beneficiaries_marketing_promotion_filter';

// Helper to get persisted filter value
const getPersistedFilterValue = () => {
  try {
    const saved = localStorage.getItem(MARKETING_FILTER_KEY);
    if (saved === 'true') return { value: true, operator: '=' };
    if (saved === 'false') return { value: false, operator: '=' };
  } catch (e) {
    // Silently handle localStorage errors
  }
  return undefined;
};

export const BeneficiariesOverview = combine(
  withTableController({ id: 'beneficiaries-table' }),
  withContext(
    'adminBeneficiariesService',
    ServicesContext,
    ({ adminBeneficiariesService }) => adminBeneficiariesService
  ),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadBeneficiaries:
        ({ adminBeneficiariesService }) =>
          (tableState, _table, query = {}) => {
            // Extract values from query
            const { beneficiaryName, ...otherFilters } = query;

            // Parse the search text for filters
            const textFilters = parseFilters(beneficiaryName);

            // Get the filter from localStorage
            const persistedFilter = getPersistedFilterValue();

            // Merge other filters (non-search) with parsed search filters
            const allFilters = { ...otherFilters, ...textFilters };

            // If marketingPromotion isn't in the current filters but we have a persisted one, use it
            if (allFilters.marketingPromotion === undefined && persistedFilter !== undefined) {
              allFilters.marketingPromotion = persistedFilter;
            }

            // Use table state sorting
            const sort = tableState.sorted || [];

            // Create API parameters
            const apiParams = {
              page: tableState.page,
              size: tableState.pageSize,
              sort: sort,
            };

            return adminBeneficiariesService.queryBeneficiaries(allFilters, apiParams);
          },

      onSearch:
        ({ table }) =>
          (query) => {
            table.search(query);
          },
    },
    []
  )
)(BeneficiariesOverviewComponent)
